import React from 'react';
import { useTheme } from '@mui/material/styles/';
import { props, defaultProps } from './entitiesIconsProps';

const EpisodeIcon = ({ width, height }) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
    >
      <path
        d="M64 112C55.16 112 48 104.8 48 96C48 87.16 55.16 80 64 80C72.84 80 80 87.16 80 96C80 104.8 72.84 112 64 112zM64 160C28.65 160 0 131.3 0 96C0 60.65 28.65 32 64 32C99.35 32 128 60.65 128 96C128 131.3 99.35 160 64 160zM96 96C96 78.33 81.67 64 64 64C46.33 64 32 78.33 32 96C32 113.7 46.33 128 64 128C81.67 128 96 113.7 96 96zM192 96C192 87.16 199.2 80 208 80H496C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H208C199.2 112 192 104.8 192 96zM192 256C192 247.2 199.2 240 208 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H208C199.2 272 192 264.8 192 256zM192 416C192 407.2 199.2 400 208 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H208C199.2 432 192 424.8 192 416zM64 192C99.35 192 128 220.7 128 256C128 291.3 99.35 320 64 320C28.65 320 0 291.3 0 256C0 220.7 28.65 192 64 192zM32 256C32 273.7 46.33 288 64 288C81.67 288 96 273.7 96 256C96 238.3 81.67 224 64 224C46.33 224 32 238.3 32 256zM64 480C28.65 480 0 451.3 0 416C0 380.7 28.65 352 64 352C99.35 352 128 380.7 128 416C128 451.3 99.35 480 64 480zM96 416C96 398.3 81.67 384 64 384C46.33 384 32 398.3 32 416C32 433.7 46.33 448 64 448C81.67 448 96 433.7 96 416z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
};

EpisodeIcon.propTypes = props;

EpisodeIcon.defaultProps = defaultProps;

export default EpisodeIcon;
